<template>
  <div class="sales project">
    <header class="project-display">
      <div class="project">
        <span class="title">{{ project.title }}</span>
        <span class="client"><MoneyDisplay :value="project.price" /></span>
        <span class="status">
          <strong :class="project.status.value">{{ project.status.label }}</strong>
        </span>
      </div>
    </header>

    <article>
      <template v-if="project.labConsultingApplied">
        <p v-if="project.labConsultingIncluded">
          {{ $t('You know your client well. You have now inluded lab-consulting in your visit.') }}
        </p>
        <p v-else>{{ $t('You do not know your client well enough to include lab-consulting in your visit.') }}</p>
      </template>

      <p>{{ $t('For further details, check your pending requests list.') }}</p>

      <div class="actions">
        <Link :href="links.back" class="button">
          {{ $t('back') }}
        </Link>
      </div>
    </article>
  </div>
</template>

<script setup lang="ts">
import { Link } from '@inertiajs/vue3'

import MoneyDisplay from '/@front:components/MoneyDisplay.vue'
import GameLayout from '/@front:layouts/game.vue'
import type { Project, ScenarioClient } from '/@front:types/shared'

defineOptions({
  layout: [GameLayout],
})

defineProps<{
  project: Project
  client: ScenarioClient
  links: Record<string, string>
}>()
</script>
